(function () {
  'use strict';
  var DAY = 86400000;
  function stamp(y,m,d) {
    var two = function(n){return String(n).padStart(2,'0');};
    return Date.parse(y+'-'+two(m)+'-'+two(d)+'T00:00:00'+(m===10?'+02:00':'+01:00'));
  }
  function friday(y) {
    var day = new Date(Date.UTC(y,10,1)).getUTCDay();
    return 1+((5-day+7)%7)+21;
  }
  function create(y) {
    var f=friday(y), out=[];
    function add(start,end,title,icon,subtitle,kind,until){
      out.push({start:start,end:end,until:until||end,title:title,icon:icon,subtitle:subtitle,kind:kind||'ends'});
    }
    add(stamp(y,10,24),stamp(y,11,1),'Halloween','🎃','Packs con hasta 27% de ahorro','ends');
    add(stamp(y,11,1),stamp(y,11,2),'Todos los Santos','✨','Ideas de regalo · Packs con ahorro','ends');
    add(stamp(y,11,2),stamp(y,11,11),'Singles Day se acerca','🖤','Packs para regalar o darte un capricho','starts');
    add(stamp(y,11,11),stamp(y,11,12),'Singles Day','🖤','Packs con hasta 27% de ahorro','ends');
    add(stamp(y,11,12),stamp(y,11,f-4),'Black Week se acerca','🖤','Prepara tus regalos · Packs con ahorro','starts');
    add(stamp(y,11,f-4),stamp(y,11,f),'Black Week','🖤','Packs con hasta 27% de ahorro','ends');
    add(stamp(y,11,f),stamp(y,11,f+3),'Black Friday','🖤','Packs con hasta 27% de ahorro','ends');
    add(stamp(y,11,f+3),stamp(y,12,1),'Cyber Monday','⚡','Packs con hasta 27% de ahorro','ends');
    add(stamp(y,12,1),stamp(y,12,24),'Navidad','🎄','Ideas de regalo desde 24,99 €','christmas',stamp(y,12,25));
    add(stamp(y,12,24),stamp(y,12,25),'Nochebuena','🎁','Regala Esenciara · Packs con ahorro','ends');
    add(stamp(y,12,25),stamp(y,12,26),'Navidad','🎄','Packs para regalar','ends');
    add(stamp(y,12,26),stamp(y+1,1,6),'Reyes','👑','Ideas de regalo · Packs con ahorro','kings');
    add(stamp(y+1,1,6),stamp(y+1,1,7),'Día de Reyes','👑','Regala Esenciara · Packs con ahorro','ends');
    return out;
  }
  function current(now){
    var y=new Date(now).getUTCFullYear(), result=null;
    for(var yr=y-1;yr<=y+1;yr++){
      var rows=create(yr);
      for(var j=0;j<rows.length;j++){
        if(now>=rows[j].start && now<rows[j].end)result=rows[j];
      }
    }
    return result;
  }
  function pad(n){return String(n).padStart(2,'0');}
  function timeLeft(ms,small){
    var sec=Math.max(0,Math.ceil(ms/1000));
    var days=Math.floor(sec/86400),h=Math.floor((sec%86400)/3600),m=Math.floor((sec%3600)/60),s=sec%60;
    if(small)return days?days+'d '+pad(h)+'h':pad(h)+'h '+pad(m)+'m';
    return days?days+'d '+pad(h)+'h '+pad(m)+'m '+pad(s)+'s':pad(h)+'h '+pad(m)+'m '+pad(s)+'s';
  }
  var announcement=document.querySelector('[data-ese-campaign-announcement]');
  var homeKicker=document.querySelector('[data-ese-campaign-home-kicker]');
  var homeNote=document.querySelector('[data-ese-campaign-home-note]');
  var productTitle=document.querySelector('[data-ese-campaign-product-title]');
  var bars=[].slice.call(document.querySelectorAll('[data-esenciara-daily-offer]'));
  var previous='';
  function update(){
    if(document.hidden)return;
    var now=Date.now(),campaign=current(now);
    var key=campaign?campaign.start+'-'+campaign.end:'neutral';
    var mobile=window.matchMedia && window.matchMedia('(max-width:749px)').matches;
    var small=campaign?timeLeft(campaign.until-now,true):'';
    var full=campaign?timeLeft(campaign.until-now,false):'';
    var status=campaign ? (campaign.kind==='starts'?'Empieza en':campaign.kind==='christmas'?'Navidad llega en':campaign.kind==='kings'?'Reyes llegan en':'El evento termina en') : '';
    if(announcement){
      var banner=campaign?
        (mobile?campaign.icon+' '+campaign.title+' · '+(campaign.kind==='starts'?'En ': 'Termina en ')+small+' · Packs con ahorro':campaign.icon+' '+(campaign.kind==='starts'?'':'Especial ')+campaign.title+' · '+status+' '+small+' · '+campaign.subtitle+' · Envío gratis'):
        'Envío gratis a España · Packs con ahorro · 30 días para devoluciones';
      if(announcement.textContent!==banner)announcement.textContent=banner;
    }
    if(key!==previous){
      if(homeKicker)homeKicker.textContent=campaign?campaign.icon+' '+(campaign.kind==='starts'?'PRÓXIMAMENTE: ':'ESPECIAL ')+campaign.title.replace(' se acerca','').toUpperCase()+' · ELIGE TU PACK':'ELIGE TU PACK';
      if(homeNote)homeNote.textContent=campaign?campaign.subtitle+' · Envío gratis a España':'Regalos que sorprenden · Packs con ahorro';
      if(productTitle)productTitle.textContent=campaign?campaign.icon+' '+(campaign.kind==='starts'?'PRÓXIMAMENTE: ':'ESPECIAL ')+campaign.title.replace(' se acerca','').toUpperCase()+' · PACKS CON AHORRO':'REGALOS ESENCIARA · PACKS CON AHORRO';
      bars.forEach(function(bar){bar.hidden=!campaign;});
      previous=key;
    }
    bars.forEach(function(bar){
      if(!campaign)return;
      var label=campaign.kind==='starts'?'Comienza en':campaign.kind==='christmas'?'Navidad llega en':campaign.kind==='kings'?'Reyes llegan en':'El evento termina en';
      bar.querySelectorAll('[data-ese-campaign-offer-copy]').forEach(function(el){if(el.textContent!==campaign.icon+' '+campaign.title+' · '+label)el.textContent=campaign.icon+' '+campaign.title+' · '+label;});
      bar.querySelectorAll('[data-esenciara-count]').forEach(function(el){if(el.textContent!==full)el.textContent=full;});
      var progress=bar.querySelector('[data-esenciara-progress]');
      if(progress){var pct=Math.max(0,Math.min(100,100*(campaign.end-now)/Math.max(1,campaign.end-campaign.start)));progress.style.width=pct.toFixed(2)+'%';}
    });
  }
  update();
  var ticker=setInterval(update,1000);
  document.addEventListener('visibilitychange',update);
  window.addEventListener('resize',update,{passive:true});
  document.addEventListener('shopify:section:load',update);
})();
